import { useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { useHistory, useLocation } from 'react-router-dom'

import SearchWithRecommendations from 'components/SearchWithRecommendations'
import allLanguages from 'consts/allLanguages'
import { customerioTracker } from 'lib'
import { useTranslate } from 'lib/tolgee'
import { PanelStore } from 'stores'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'
import { getTerritoryUrlByTerritoryId } from 'utils/getTerritoryUrlByTerritoryId'

import FiltersView from './components/FiltersView'
import RelatedTerritoriesView from './components/RelatedTerritoriesView'
import { GET_TERRITORY_SUGGESTION } from './query'

export default function WinninTopicsTab() {
  const [searchFilter, setSearchFilter] = useState('')

  const t = useTranslate()
  const history = useHistory()
  const location = useLocation()

  const workspaceId = (PanelStore?.selectedPanel as any)?.id

  const [getSuggestions] = useLazyQuery(GET_TERRITORY_SUGGESTION)

  const trackChanges = (category, value) => {
    const { FILTER } = analyticsTracker.eventNames
    const { SEARCH_MADE } = customerioTracker.eventNames

    const event = {
      Page: 'Search Topics Page',
      Filter: category,
      'Filter label': value?.label ? value?.label : value,
    }

    analyticsTracker.eventTrack(FILTER, event)

    customerioTracker.track(SEARCH_MADE, {
      type: 'territories',
      search_term: value?.label ? value?.label : value,
    })
  }

  const handleSelectTerritory = territory => {
    document.querySelector('input').blur()
    if (territory?.value) {
      const territoryURL = getTerritoryUrlByTerritoryId(territory.value, workspaceId)
      history.push(territoryURL)
      return
    }
    setSearchFilter(territory?.search)
    trackChanges('title', territory?.search)
  }

  const formatTerritoryForOption = territory => {
    const language = territory?.language
    const categoryTitle = territory?.category?.title
    const topicTitle = territory?.topic?.title
    const languageObject = allLanguages.find(item => item.value === language)
    const languageLabel = languageObject?.label ? t(TOLGEE_GLOBALS?.[language]) : t(TOLGEE_GLOBALS.music)
    const languageSubtitle = `${languageLabel} - ${categoryTitle || topicTitle}`
    const ownedTopic = t(TOLGEE_GLOBALS.ownedTopic)

    return {
      label: territory?.title ?? territory?.name,
      subLabel: language ? languageSubtitle : ownedTopic,
      value: territory?.territoryId,
    }
  }

  const formatTerritories = territories => {
    const topics = territories?.topics || []
    const subtopics = territories?.subtopics || []
    const savedPostSearches = territories?.savedPostSearches?.entities || []
    const unifiedTerritories = [...topics, ...subtopics, ...savedPostSearches]

    const formattedTerritories = unifiedTerritories.map(item => formatTerritoryForOption(item))

    return formattedTerritories
  }

  const searchTerritories = (search, callback) => {
    getSuggestions({ variables: { term: search } })
      .then(res => {
        const defaultValue = {
          label: t({
            key: 'SearchTopicsPage-seeResults',
            defaultValue: 'Ver resultados para: "{search}"',
            parameters: { search },
          }),
          subLabel: null,
          value: null,
          searchTerm: search,
          search,
        }
        const response = res?.data?.getSuggest ?? {}
        const formattedData = formatTerritories(response)
        const territoriesWithSearch = formattedData.map(item => {
          return {
            ...item,
            searchTerm: search,
          }
        })
        if (territoriesWithSearch.length > 0) {
          return [defaultValue, ...territoriesWithSearch].map(item => {
            return {
              ...item,
              onClick: () => handleSelectTerritory(item),
            }
          })
        }
        return territoriesWithSearch.map(item => {
          return {
            ...item,
            onClick: () => handleSelectTerritory(item),
          }
        })
      })
      .then(callback)
  }

  const handleSubmit = value => {
    document.querySelector('input').blur()

    history.replace(location.pathname)
    setSearchFilter(value)
    trackChanges('title', value)
  }

  return (
    <div className="WinninTopicsTab-wrapper">
      <div className="searchBar">
        <SearchWithRecommendations
          handleOnChange={handleSelectTerritory}
          onType={searchTerritories}
          placeholder={t(TOLGEE_GLOBALS.search)}
          onSubmit={handleSubmit}
          isCustomOption
        />
      </div>
      {searchFilter ? <RelatedTerritoriesView search={searchFilter} /> : <FiltersView searchFilter={searchFilter} />}
    </div>
  )
}
